export default {
  __html: `<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <g transform="translate(-163.000000, -33.000000)" stroke="currentColor" stroke-width="2">
                    <g id="Group" transform="translate(164.000000, 31.000000)">
                        <polyline id="Path-2" transform="translate(3.000000, 8.000000) scale(-1, 1) rotate(-90.000000) translate(-3.000000, -8.000000) " points="-2 5.55487907 2.97240905 10.5 8 5.5"></polyline>
                    </g>
                </g>
            </g>`
}
